import React, { useState } from 'react';
import { Icon, Button, Loading, Dialog } from '@tencent/spaui';
import BaseInfo from './formComponent/BaseInfo';
import CompanyInfo from './formComponent/CompanyInfo';
import QualifyInfo from './formComponent/QualifyInfo';
import Ability from './formComponent/Ability';
import Deal from './formComponent/Deal';
import SubmitSuccess from './formComponent/SubmitSuccess';
import { post } from 'store/request';
import { report } from 'store/report';
import { RegistContext } from './context';
import './index.scss';
import FileUpload from 'pages/regist/components/FileUpload';

interface StageProps {
  formData: { [key: string]: any };
  stage: number;
  onSubmit?: (data: any) => void;
}

const NextStep: React.FC<{ submit: () => void }> = (props) => (
  <Button className="next-step" displayType="primary" onClick={props.submit}>
    下一步
  </Button>
);

const StageInfo: React.FC<StageProps> = (props) => {
  const state2component: {
    [key: number]: React.FC<{ onSubmit?: (data: any) => void; initData: { [key: string]: any }; children: React.FC }>;
  } = {
    0: BaseInfo,
    1: CompanyInfo,
    2: QualifyInfo,
    3: Ability,
    4: Deal,
    5: SubmitSuccess,
  };
  const Component = state2component[props.stage];
  const { formData, stage } = props;
  return (
    <Component initData={formData[stage] || {}} onSubmit={props.onSubmit}>
      {NextStep}
    </Component>
  );
};

const Regist: React.FC = () => {
  const tapList = ['基本信息', '公司信息', '资质信息', '能力举证', '协议签署'];
  const [status, setStatus] = useState(0);
  const [formData, setFormData] = useState<{ [key: number]: any }>({});
  const [loading, setLoading] = useState(false);
  const [userIdentity, setIdentity] = useState('');
  const [show, setShow] = useState(false);
  const [authorize_file, set_authorize_file] = useState([]); // 开户账号使用授权书

  const changeStatus = (index: number) => {
    // 第 0 步不许回退
    if (index === 0) {
      return;
    }
    // 提交成功页面不许回退
    if (status >= tapList.length) {
      return;
    }
    if (index < status) {
      setStatus(index);
    }
  };

  const onSubmit = (data: any) => {
    // 第一页信息直接提交
    formData[status] = data;
    setFormData({
      ...formData,
    });
    if (status === 0) {
      setLoading(true);
      post('/agency/reg_create', data)
        .then((res) => {
          setIdentity(res.flow_key);
          setShow(true);
          // updateStatus();
        })
        .finally(() => setLoading(false));
    } else {
      if (status === tapList.length - 1) {
        let data: { [key: string]: any } = {};
        Object.values(formData).forEach((item) => {
          data = { ...item, ...data };
        });
        data.flow_key = userIdentity;
        data.authorize_file = authorize_file; // 开户账号使用授权书
        data.icp_no = data.icp_no.map((item: { url: string }) => item.url).join(','); // 应需求改动，调整 icp_no ICP 证件号格式
        setLoading(true);
        post('/agency/reg_submit', data)
          .then(() => {
            updateStatus();
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        updateStatus();
      }
    }
  };

  const updateStatus = () => {
    if (location.pathname === '/regist') {
      report({ event: 'regist_page', payload: tapList[status] });
    }
    setStatus(status + 1);
  };

  return (
    <div className="regist-content">
      <RegistContext.Provider value={{ userIdentity }}>
        <div className="left-bar">
          {tapList?.map((item, index) => (
            <div
              key={index}
              className={`button ${index === status ? 'active' : ''} ${index !== 0 && index < status ? 'pointer' : ''}`}
              onClick={() => changeStatus(index)}
            >
              <span>{item}</span>
              {index < status ? <Icon name="check-bold-outlined" /> : <span>···</span>}
            </div>
          ))}
        </div>
        <div className="form-info">
          <h2>{tapList[status]}</h2>
          <StageInfo formData={formData} stage={status} onSubmit={onSubmit} />
        </div>
      </RegistContext.Provider>
      <Dialog
        moveable
        type="normal"
        show={show}
        onClose={() => {
          updateStatus();
          setShow(false);
        }}
        onSubmit={() => {
          updateStatus();
          setShow(false);
        }}
        onCancel={() => {
          updateStatus();
          setShow(false);
        }}
        title="上传授权书"
        style={{
          width: '600px',
        }}
      >
        <FileUpload
          flow_key={userIdentity}
          value={authorize_file?.[0]?.file_url}
          onDelete={() => set_authorize_file([])}
          onChange={(data, name: string) => {
            set_authorize_file([
              {
                file_url: data,
                file_name: name,
              },
            ]);
          }}
        />
        <div style={{ padding: '8px 0' }}>
          下载模板
          <a
            target="_blank"
            href="https://docs.qq.com/doc/DWXhsWG9RaEJtY2FW"
            style={{ color: '#0061e7' }}
            rel="noreferrer"
          >
            【ISV模版】QQ微信注册使用授权书-模版
          </a>
        </div>
      </Dialog>
      <Loading show={loading} type="page" />
    </div>
  );
};

export default Regist;
